module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('industry-single', {
    scopedSlots: _vm._u([{
      key: "hero",
      fn: function() {
        return [_c('hero-full', {
          attrs: {
            "imageName": "industries/working-capital-financing-banner.jpg",
            "altText": "Man next to the construction vehicle",
            "ctaButtonTitle": "Check Eligibility"
          },
          scopedSlots: _vm._u([{
            key: "content",
            fn: function() {
              return [_c('h1', [_vm._v("Working Capital Financing")]), _vm._v(" "), _c('p', [_vm._v("Business Loans | Fast Funding")])]
            },
            proxy: true
          }])
        })]
      },
      proxy: true
    }, {
      key: "form-section",
      fn: function() {
        return [_c('FormSection', {
          scopedSlots: _vm._u([{
            key: "content",
            fn: function() {
              return [_c('h2', [_c('span', [_vm._v("American Credit:")]), _vm._v(" Empowering businesses everyday with working capital loans.\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n         Small businesses are the engine of the American economy. Access to well-priced working capital is vital. At American Credit, we pride ourselves on providing small businesses with business term loans, lines of credit, and other custom working capital options. Many of our custom programs  are unsecured , have set monthly payments and no prepayment penalty. They are designed to be as flexible as possible, meaning your funds can be used for almost any business purpose. "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n         Applying with American Credit has no effect on your credit score and repaying your loan on time even helps your business build good credit. It is a simple, fast, and fully digital process with 48-hour funding. \n        ")])]
            },
            proxy: true
          }, {
            key: "logos",
            fn: function() {
              return [_c('div', {
                staticClass: "row"
              }, [_c('div', {
                staticClass: "col-12 col-md-5 order-md-2 d-flex"
              }, [_c('div', {
                staticClass: "row logos-brands"
              }, [_c('div', {
                staticClass: "col-6 col-md-12"
              }, [_c('a', {
                attrs: {
                  "href": "https://www.bbb.org/us/ca/palo-alto/profile/financial-services/american-credit%C2%AE-inc-1216-1079741",
                  "target": "_blank"
                }
              }, [_c('img', {
                attrs: {
                  "src": "/static/assets/imgs/industries/bbba-logo.png",
                  "alt": "BBBA logo"
                }
              })])])])]), _vm._v(" "), _c('div', {
                staticClass: "col-12 col-md-7"
              }, [_c('img', {
                attrs: {
                  "src": "/static/assets/imgs/industries/google-review.png",
                  "alt": "Google Review"
                }
              })])])]
            },
            proxy: true
          }])
        })]
      },
      proxy: true
    }, {
      key: "first-row",
      fn: function() {
        return [_c('RowSection', {
          attrs: {
            "img-side": "left",
            "imageName": "industries/working-capital-financing1.jpg",
            "altText": "A smiling man wearing a hard hat and holding a tablet",
            "backgroundPrimary": "#00234D",
            "backgroundSecondary": "#F6F9FE",
            "displayCtaButton": false
          },
          scopedSlots: _vm._u([{
            key: "content",
            fn: function() {
              return [_c('h2', [_vm._v("Business Line of Credit")]), _vm._v(" "), _c('p', [_vm._v("\n        A business line of credit allows you to get approved for the money you need, and to only pay interest on the money you borrow. Borrow whatever you need, when you need it. A business line of credit will help cover recurring business expenses or bridge any unexpected cash flow gaps along the way. Once you pay your American Credit loan off, you can now use your open line of credit again."), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n        Use your business line of credit to bridge any cash flow gaps, purchase inventory, repair faulty equipment, or for marketing & advertising purposes. American Credit provides access to unsecured & secured business lines of credit whenever you need it. \n        ")])]
            },
            proxy: true
          }])
        })]
      },
      proxy: true
    }, {
      key: "second-row",
      fn: function() {
        return [_c('RowSection', {
          attrs: {
            "img-side": "right",
            "imageName": "industries/working-capital-financing2.jpg",
            "altText": "A smiling woman wearing a hard hat and holding a tablet",
            "displayCtaButton": false
          },
          scopedSlots: _vm._u([{
            key: "content",
            fn: function() {
              return [_c('h2', [_vm._v("Construction Worker")]), _vm._v(" "), _c('p', [_vm._v("\n          American Credit’s equipment-secured term loans and sale leaseback are gamechangers for growing businesses.  They are a great way for companies with free and clear equipment to unlock their equity for needed working capital. Our custom programs include loans with no minimum FICO score, no financials needed , and fully amortized term loans. These programs are a great pivot from expensive short term merchant cash advances.  \n        ")])]
            },
            proxy: true
          }])
        })]
      },
      proxy: true
    }, {
      key: "third-row",
      fn: function() {
        return [_c('IconsGrid', {
          attrs: {
            "gridElements": _vm.gridItems
          },
          scopedSlots: _vm._u([{
            key: "title",
            fn: function() {
              return [_vm._v("Geared to Your Needs and Your Business")]
            },
            proxy: true
          }])
        })]
      },
      proxy: true
    }, {
      key: "fourth-row",
      fn: function() {
        return [_c('TablesSection', {
          attrs: {
            "tables": _vm.tableItems
          },
          scopedSlots: _vm._u([{
            key: "title",
            fn: function() {
              return [_vm._v("Working Capital Loan Requirements")]
            },
            proxy: true
          }, {
            key: "text",
            fn: function() {
              return [_vm._v("Minimum loan requirements to expedite approval & secure quick\n        funding.")]
            },
            proxy: true
          }])
        })]
      },
      proxy: true
    }, {
      key: "fifth-row",
      fn: function() {
        return [_c('RowSection', {
          staticClass: "lei-section",
          attrs: {
            "img-side": "right",
            "imageName": "industries/Lei-li-formal.jpeg",
            "altText": "photo Dr. Lei Li, CEO of American Credit, Inc., in blue suit smiling"
          },
          scopedSlots: _vm._u([{
            key: "content",
            fn: function() {
              return [_c('h2', [_c('span', [_vm._v("American Credit:")]), _vm._v(" The Difference You Can Trust")]), _vm._v(" "), _c('p', [_vm._v("\n          Your business is not JUST a business. It’s YOURS. It’s your\n          livelihood. It’s your passion. American Credit completely\n          understands this. We help business owners just like you everyday, by\n          taking a wholistic approach to business financing.\n          "), _c('strong', [_vm._v("Dr. Lei Li, PhD, CFA, & CEO of American Credit")]), _vm._v(", is\n          an Economist who uses his 20+ years of industry experience to help\n          business owners achieve their American Dream:\n          "), _c('strong', [_vm._v("successful business ownership")]), _vm._v(". "), _c('br'), _c('br'), _vm._v("\n          Whatever financial situation you’re in, American Credit has your\n          back. Apply for your business loan today!\n        ")])]
            },
            proxy: true
          }, {
            key: "button-contact",
            fn: function() {
              return [_c('contact-info', {
                staticClass: "d-none d-md-flex",
                attrs: {
                  "imageName": "Lei_Li.png",
                  "altText": "Lei's photo",
                  "title": "Call Lei",
                  "contactType": "Service",
                  "phoneNumber": "650-885-8055"
                }
              })]
            },
            proxy: true
          }])
        })]
      },
      proxy: true
    }, {
      key: "google-reviews",
      fn: function() {
        return [_c('div', {
          staticClass: "elfsight-app-8279c03d-9a65-4465-b949-ecb8d18697e0"
        })]
      },
      proxy: true
    }])
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-02d9d9ef"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/industries/workingCapitalFinancing.vue
// module id = 1927
// module chunks = 5